export default function loadCitiesInRegionArea(regionAreaId, callback) {
  fetch(`/cities?region_area_id=${regionAreaId}`)
    .then(response => response.json())
    .then(callback)
    .catch(error => {
      console.error('Error:', error)
    })
}
